<template>
	<div>
		<!-- 头部 -->
		<vm-header :inputName='Name'></vm-header>
		<!-- 头部 -->
		<!-- 内容 -->
		<div class="container">
			<div class="Beijing">
				<span>开通高考志愿VIP&nbsp;&nbsp;享会员专属福利</span>
				<span>【充值会员享优惠&nbsp;VIP畅享专属福利】</span>
			</div>
			<div class="Main">
				<div class="Main_top">
					<figure>
						<img src="../../src/assets/img/vipshu.png" alt="">
						<figcaption>高考志愿会员享<span>3</span>大特权</figcaption>
					</figure>
				</div>
				<div class="Main_con">
					<div class="hx_hezi">
						<figure class="hezi1">
							<img src="../../src/assets/img/ZSHzj.png" alt="">
							<figcaption>专家指导</figcaption>
						</figure>
						<div class="hezi2">
							<div class="em"></div>
							<div class="hezi2_wz">专家一对一指导</div>
							<div class="em"></div>
						</div>
						<div class="hezi3">专家一对一指导</div>
						<div class="hezi3">无门槛</div>
					</div>
					<div class="hx_hezi">
						<figure class="hezi1">
							<img src="../../src/assets/img/ZSHcx.png" alt="">
							<figcaption>查询志愿</figcaption>
						</figure>
						<div class="hezi2">
							<div class="em"></div>
							<div class="hezi2_wz">免费查询志愿</div>
							<div class="em"></div>
						</div>
						<div class="hezi3">免费查询志愿</div>
						<div class="hezi3">会员可生成高质量志愿</div>
					</div>
					<div class="hx_hezi">
						<figure class="hezi1">
							<img src="../../src/assets/img/ZSHsf.png" alt="">
							<figcaption>修改省份</figcaption>
						</figure>
						<div class="hezi2">
							<div class="em"></div>
							<div class="hezi2_wz">免费修修改省份</div>
							<div class="em"></div>
						</div>
						<div class="hezi3">免费修改高考省份</div>
						<div class="hezi3">不限次数</div>
					</div>
				</div>
				<div class="Bot" @click="pay()">
					<div class="Bot_AA"><span>确认开通</span><span>15元/月</span></div>
				</div>
			</div>
			<div class="mask" v-if="isPay">
				<div class="mask_AAA">
					<div class="Pay_top">
						<img @click="close()" src="../../src/assets/img/vipcha.png" alt="">
						<span class="onespan">开通高考志愿VIP</span>
						<div class="Pay_top_xia">
							<span>提升填报效率</span>
							<span>精准无误提供方案</span>
							<span>VIP专享福利</span>
						</div>
					</div>
					<div class="Pay_con">
						<div class="Pay_con_je">应付金额：<span>15</span>元</div>
						<div class="Pay_con_ewm">
							<figure class="wxpay">
								<div class="imgk">
									<img src="../../src/assets/img/payewm.png">
								</div>
								<div class="wxzf">
									<img src="../../src/assets/img/Vx.png" alt="">
									<figcaption class="Vxgreen">微信支付</figcaption>
								</div>
							</figure>
							<figure class="wxpay">
								<div class="imgk zfbpay">
									<img src="../../src/assets/img/payewm.png">
								</div>
								<div class="wxzf">
									<img src="../../src/assets/img/zfb.png" alt="">
									<figcaption class="zfbblue">支付宝支付</figcaption>
								</div>
							</figure>
						</div>
					</div>
				</div>
			</div>
		</div>
		<item7></item7>
	</div>
</template>
<script>
	import vmHeader from "../components/vmHeader.vue";
	import item7 from "../components/item7.vue";
	export default {
		props: [],
		components: {
			vmHeader,
			item7
		},
		data() {
			return {
				// 导航选中
				Name:8,
				isPay: false,
				
			}
		},
		computed: {},
		methods: {
			pay() {
				this.isPay = true;
			},
			close() {
				this.isPay = false;
			}
		},
		mounted() {},
	};
</script>
<style scoped>
	@media (min-width:1400px) {
		.container {
			width: 1530px;
			box-sizing: border-box;
		}
	}

	.Beijing {
		width: 100%;
		height: 200px;
		background-image: url(../../src/assets/img/Vip.png);
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.Beijing span:nth-of-type(1) {
		font-size: 48px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-bottom: 20px;
	}

	.Beijing span:nth-of-type(2) {
		font-size: 28px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
	}

	.Main {
		width: 100%;
		height: 475px;
		background: rgba(255, 255, 255, 0.39);
		border-radius: 5px;
		margin-top: 40px;
	}

	.Main .Main_top {
		width: 1460px;
		height: 68px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
		margin: auto;
	}

	.Main_top figure {
		display: flex;
		align-items: center;
	}

	.Main_top figure img {
		width: 7px;
		height: 24px;
		margin-right: 10px;
	}

	.Main_top figure figcaption {
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}

	.Main_top figure figcaption span {
		color: #F53824;
	}

	.Main_con {
		margin-top: 40px;
		width: 100%;
		height: 215px;
		display: flex;
		justify-content: space-evenly;
		margin-bottom: 50px;
	}

	.Main_con .hx_hezi {
		width: 420px;
		height: 215px;
		background-color: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 0px 10px rgb(0 0 0 / 6%);
		border-radius: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.hx_hezi .hezi1 {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.hezi1 img {
		width: 22px;
		height: 22px;
		margin-right: 6px;
	}

	.hezi1 figcaption {
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
	}

	.hezi2 {
		display: flex;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 30px;
	}

	.hezi2 .em {
		width: 82px;
		height: 2px;
		background: #FE9603;
		opacity: 1;
		border-radius: 4px;
	}

	.hezi2 .hezi2_wz {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #FE9603;
		margin: 0 10px;
	}

	.hezi3 {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #666666;
		opacity: 1;
		margin-bottom: 20px;
	}

	.Main .Bot {
		width: 100%;
		display: flex;
		cursor: pointer;
		justify-content: center;
	}

	.Main .Bot .Bot_AA {
		width: 324px;
		height: 52px;
		background: linear-gradient(92deg, #F53824 0%, #FE9603 100%);
		border-radius: 26px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Main .Bot .Bot_AA span {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 37px;
		color: #FFFFFF;
	}

	.Main .Bot .Bot_AA span:nth-of-type(1) {
		margin-right: 20px !important;
	}

	.mask {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.39);
	}

	.mask_AAA {
		width: 960px;
		height: 602px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgb(255, 255, 255);
		border-radius: 20px 20px 0px 0px;
	}

	.mask_AAA .Pay_top {
		width: 960px;
		height: 100px;
		background-image: url(../../src/assets/img/pay.png);
		background-size: 100% 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.Pay_top img {
		width: 28px;
		height: 28px;
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	.onespan {
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-bottom: 10px;
	}

	.Pay_top .Pay_top_xia {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		width: 320px;
		height: 24px;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.Pay_con {
		width: 100%;
		height: calc(100% - 100px);
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.Pay_con .Pay_con_je {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
		margin: 30px 0;
	}

	.Pay_con .Pay_con_je span {
		color: #F53824;
	}

	.Pay_con .Pay_con_ewm {
		width: 706px;
		height: 364px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px dashed #999999;
		display: flex;
		justify-content: space-evenly;
		padding-top: 50px;
		box-sizing: border-box;
	}

	.Pay_con_ewm .wxpay {
		width: 213px;
		height: auto;
		display: flex;
		flex-direction: column;
	}

	.wxpay .imgk {
		width: 213px;
		height: 213px;
		border: 1px solid #00B54F;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 14px;
	}

	.wxpay .wxzf {
		display: flex;
		justify-content: center;
	}

	.wxzf {
		align-items: center;
	}

	.wxzf img {
		width: 25px;
		height: 25px;
		margin-right: 10px;
	}

	.wxzf .Vxgreen {
		font-size: 26px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #00B54F;
	}

	.zfbpay {
		border: 1px solid #29A7E1 !important;
	}

	.wxzf .zfbblue {
		font-size: 26px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1 !important;
	}

	@media(max-width:1400px) {
		.Main {
			height: auto;
		}

		.Main_top {
			width: 100% !important;
		}

		.Main_top figure {
			justify-content: center;
		}

		.Main_con {
			height: auto;
			flex-direction: column;
			align-items: center;
		}

		.Main_con .hx_hezi {
			width: 100%;
			margin-bottom: 20px;
		}

		.mask_AAA {
			width: 80%;
			height: 80%;
		}

		.mask_AAA .Pay_top {
			width: 100% !important;
		}
	}

	@media(max-width:980px) {
		.Beijing span {
			font-size: 29px !important;
		}

		.Main {
			height: auto;
		}

		.Main_top {
			width: 100% !important;
		}

		.Main_top figure {
			justify-content: center;
		}

		.Main_con {
			height: auto;
			flex-direction: column;
			align-items: center;
		}

		.Main_con .hx_hezi {
			width: 100%;
			margin-bottom: 20px;
		}

		.mask_AAA {
			width: 80%;
			height: 80%;
		}

		.mask_AAA .Pay_top {
			width: 100% !important;
		}

		.Pay_con .Pay_con_ewm {
			width: 80%;
		}
	}

	@media(max-width:750px) {
		.Beijing span {
			font-size: 29px !important;
		}

		.Main {
			height: auto;
		}

		.Main_top {
			width: 100% !important;
		}

		.Main_top figure {
			justify-content: center;
		}

		.Main_con {
			height: auto;
			flex-direction: column;
			align-items: center;
		}

		.Main_con .hx_hezi {
			width: 100%;
			margin-bottom: 20px;
		}

		.mask_AAA {
			width: 80%;
			height: 80%;
		}

		.mask_AAA .Pay_top {
			width: 100% !important;
		}

		.Pay_con .Pay_con_ewm {
			width: 80%;
		}

		.wxpay .imgk {
			width: 160px;
			height: 160px;
		}

		.wxpay .imgk img {
			width: 90%;
			height: 90%;
		}

		.Pay_con_ewm .wxpay {
			width: 100%;
			align-items: center;
		}
	}

	@media(max-width:550px) {
		.Beijing span {
			font-size: 19px !important;
		}

		.Beijing {
			height: 150px;
		}

		.mask_AAA {
			width: 80%;
			height: 60%;
		}

		.mask_AAA .Pay_top {
			width: 100% !important;
			height: 83px;
		}

		.Pay_con .Pay_con_ewm {
			width: 87%;
			height: 60%;
		}

		.wxpay .imgk {
			width: 120px;
			height: 120px;
		}

		.wxpay .imgk img {
			width: 90%;
			height: 90%;
		}

		.Pay_con_ewm .wxpay {
			width: 100%;
			align-items: center;
		}

		.wxpay .wxzf {
			width: 100%;
		}

		.wxzf .zfbblue {
			font-size: 16px;
		}

		.wxzf .Vxgreen {
			font-size: 16px;
		}

		.Pay_top .Pay_top_xia {
			width: 260px;
		}

		.Pay_top img {
			position: absolute;
			top: 10px;
			right: 10px;
		}

		.onespan {
			font-size: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/Vip.vue